import React from "react";

import Login from "../public-app/login";

import AddUser from "../public-app/user/AddUser";

import Forget from "../public-app/forget/Forget";
import ForgetReset from "../public-app/forget/ForgetReset";

import Dashboard from "../private-app/dashboard";
import Users from "../private-app/users/index";
import EditUser from "../private-app/users/EditUser";
import SubModulos from "../private-app/dashboard/subModulo";
import AvaliacaoGenetica from "../private-app/avaliacaoGenetica";
import GraficoEvolucaoGenetica from "../private-app/graficoEvolucaoGenetica";
import EficienciaReprodutiva from "../private-app/eficienciaReprodutiva/index"

import UsuarioConfirmacao from "../private-app/usuario-confirmacao";

export const Index = (props) => (
  <>
    <Login title="Login Admin" />
  </>
);

export {
  Login,
  AddUser,
  Forget,
  ForgetReset,
  Dashboard,
  Users,
  EditUser,
  AvaliacaoGenetica,
  SubModulos,
  UsuarioConfirmacao,
  GraficoEvolucaoGenetica,
  EficienciaReprodutiva
};
